import React, { useEffect } from "react";
import "../css/main.scss";
import Header from "./common/Header";
import Footer from "./common/Footer";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import Donations from "./Donations";
import LocalStorageUtil from "../utils/localStorageUtil";
import { BASE_URL } from "../constans/ApiEndpointConstants";
import { sendMessage } from "../apis/SendMessageAPI";

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrow custom-arrow--next`}
      style={{ ...style }}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faChevronRight} />
    </div>
  );
};

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrow custom-arrow--prev`}
      style={{ ...style }}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faChevronLeft} />
    </div>
  );
};

const Main = () => {
  const navigate = useNavigate();
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const bannerSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "60px",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerPadding: "40px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: "30px",
        },
      },
    ],
  };

  const banners = [
    { id: 1, img: "/main-jp/main2-1.jpg" },
    { id: 2, img: "/main-jp/main2-2.jpeg" },
    { id: 3, img: "/main-jp/main2-3.png" },
    { id: 4, img: "/main-jp/main2-4.png" },
    { id: 5, img: "/main-jp/main2-5.jpg" },
  ];

  const storedAd = LocalStorageUtil.getAd();
  const ad = storedAd || "donation";

  useEffect(() => {
    const userid = localStorage.getItem("userid");
    const message = `${BASE_URL} [Main page]:ad=${ad}:userid=${userid}`;
    sendMessage(message);
  }, [ad]);

  return (
    <div className="layout">
      <Header />
      <main className="main-content">
        <section className="hero">
          <div className="hero__container">
            <h1 className="hero__title">
              <span className="hero__title-line">いまより一歩、</span>
              <span className="hero__title-line">好きなほうの未来へ。</span>
            </h1>
            <div className="hero__buttons">
              <button
                className="hero__btn hero__btn--primary"
                onClick={() => {
                  navigate("/donations");
                  toTop();
                }}
              >
                プロジェクトをさがす
              </button>
            </div>
          </div>
        </section>

        <section className="banner-carousel">
          <Slider {...bannerSettings}>
            {banners.map((banner) => (
              <div key={banner.id} className="banner-item">
                <a href="/donations" className="banner-link">
                  <img src={banner.img} alt={`バナー ${banner.id}`} />
                </a>
              </div>
            ))}
          </Slider>
        </section>

        {/* 3 */}
        <Donations />

        <section className="about-cf">
          <div className="about-cf__inner">
            <div className="about-cf__content">
              <h2 className="about-cf__title">
                クラウドファンディング（クラファン）とは？
              </h2>
              <p className="about-cf__desc">
                クラウドファンディング（crowdfunding）とは群衆（crowd）と資金調達（funding）を組み合わせた造語で、インターネットを通して自分の活動や夢を発信することで、想いに共感した人や活動を応援したいと思ってくれる人から資金を募るしくみです。途上国支援や商品開発、自伝本の制作など幅広いプロジェクトが実施されています。
              </p>
            </div>
            <div className="about-cf__img">
              <img src="/main-jp/main3.svg" alt="クラウドファンディングとは" />
            </div>
            <div className="about-cf__btn-wrap">
              <button className="about-cf__btn" onClick={() => navigate("#")}>
                もっと詳しく
              </button>
            </div>
          </div>
        </section>

        <section className="monthly-support">
          <div className="monthly-support__inner">
            <div className="monthly-support__content">
              <h2 className="monthly-support__title">
                マンスリーサポーター 募集
              </h2>
              <p className="monthly-support__desc">
                毎月の定額支援で、より長く活動を応援できる継続寄付。
                サービス開始から1周年を迎えました。
              </p>
              <div className="monthly-support__img-mobile">
                <img src="/main-jp/main4.png" alt="マンスリーサポーター" />
              </div>
              <button
                className="monthly-support__btn"
                onClick={() => {
                  navigate("/donations");
                  toTop();
                }}
              >
                継続寄付のプロジェクトをご検討の方へ
              </button>
            </div>
            <div className="monthly-support__img-desktop">
              <img src="/main-jp/main4.png" alt="マンスリーサポーター" />
            </div>
          </div>
        </section>

        <hr className="css-16sc14z" />

        <section className="interviews">
          <div className="interviews__inner">
            <h2 className="interviews__section-title">
              クラウドファンディング 実行者インタビュー
            </h2>
            <div className="interviews__grid">
              <div className="interviews__card">
                <div className="interviews__img-wrap">
                  <img
                    src="/main-jp/main5-1.jpg"
                    alt="インタビュー1"
                    className="interviews__img"
                  />
                </div>
                <h3 className="interviews__title">
                  ９億円を集めた国立科学博物館が語る、舞台裏とその後。
                </h3>
                <p className="interviews__desc">
                  国立科学博物館 篠田謙一館長、有田寛之センター長
                </p>
              </div>
              <div className="interviews__card">
                <div className="interviews__img-wrap">
                  <img
                    src="/main-jp/main5-2.jpg"
                    alt="インタビュー2"
                    className="interviews__img"
                  />
                </div>
                <h3 className="interviews__title">
                  チケットを売らない奇跡のフェス。寄付でつくる新しい音楽の循環。
                </h3>
                <p className="interviews__desc">日比谷音楽祭実行委員会</p>
              </div>
              <div className="interviews__card">
                <div className="interviews__img-wrap">
                  <img
                    src="/main-jp/main5-3.jpg"
                    alt="インタビュー3"
                    className="interviews__img"
                  />
                </div>
                <h3 className="interviews__title">
                  お金だけでなく民意も集める。プロジェクトの反響と決意。
                </h3>
                <p className="interviews__desc">
                  京都大学野生動物研究センターの研究施設「熊本サンクチュアリ」
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Main;
